import React from 'react'
import PropTypes from 'prop-types'

const ErrorMessageContent = ({ title, content, actions }) => {
    return (
        <div className="error-message-content">
            {title && <h5 className="error-title">{title}</h5>}
            <div className="error-content">
                {content}
            </div>
            {actions && (
                <div className="error-actions action-wrapper">
                    {actions}
                </div>
            )}
        </div>
    )
}

ErrorMessageContent.propTypes = {
    content: PropTypes.any.isRequired,
    title: PropTypes.string,
    actions: PropTypes.node,
}

export default ErrorMessageContent
